import { render, staticRenderFns } from "./AboutAM.vue?vue&type=template&id=79f4195d&"
import script from "./AboutAM.vue?vue&type=script&lang=js&"
export * from "./AboutAM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports